module.exports = __webpack_public_path__ + "img/career-b2.ca171806.jpg";